module.exports = __webpack_public_path__ + "static/media/poo.f7c33ad5.svg";